import 'react-app-polyfill/stable';

import React from 'react';
import { createRoot } from 'react-dom/client';

// core
import { App } from '_core/components/App';
import * as serviceWorker from '_core/utils/serviceWorker';

const init = async () => {
  const config = await import(`${process.env.REACT_APP_PROJECT}/config`);
  const { slots } = await import(`${process.env.REACT_APP_PROJECT}/slots`);
  const { routes } = await import(`${process.env.REACT_APP_PROJECT}/routes`);
  const { menus } = await import(`${process.env.REACT_APP_PROJECT}/menus`);
  const { themes } = await import(`${process.env.REACT_APP_PROJECT}/themes`);

  const root = createRoot(document.getElementById('app'));
  root.render(
      <App
        globalContext={{
          config,
          menus,
          slots,
          routes,
          themes
        }}
      />
  );
  
  // Регистрация Service Worker в production режиме
  if (process.env.NODE_ENV === 'production') {
    serviceWorker.register({
      onUpdate: (registration) => {
        // Кастомная обработка обновления
        // UpdateNotification компонент обработает это автоматически
        console.log('[Service Worker] Update available');
      }
    });
  } else {
    // В development режиме отключаем Service Worker
    serviceWorker.unregister();
  }
};

init();
